export default function initializeWooSidebarCategories() {
    document.querySelectorAll('.block-woo-sidebar-categories').forEach(function (block) {
        new WooSidebarCategories(block);
    });
}

class WooSidebarCategories {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {

        // Pobieramy tytuł, który będzie służył jako przycisk do rozwijania/zwijania listy
        const title = this.block.querySelector('.sidebar-categories__title');
        if (!title) return;

        // Po kliknięciu przełączamy klasę .open na głównym bloku
        title.addEventListener('click', (e) => {
            e.preventDefault();
            this.block.classList.toggle('open');
        });

    }
}
